import Cta from "~components/Cta";
import SearchSelect from "~components/SearchSelect";
import WalletLayout from "~pages/Wallet/components/WalletLayout";

import CreateEditForm from "./components/CreateEditForm";
import useWalletCreate from "./hooks/useWalletCreate";

import "../styles.scss";
import { Spinner } from "@chakra-ui/react";
import { useState } from "react";
import { useConfigureFooter } from "~hooks/useHelpers";
import FormList from "./components/FormList";

const ReceiverSenderForm = () => {
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(null);

  useConfigureFooter({
    form: true,
    formId: "prospect",
    submitLabel: "Avançar",
    disabled: !cliente,
    selectButton: "button-submit",
  }, [!!cliente]);

  const [loading, setLoading] = useState(false);
  const clickProposta = (item) => {
    setCliente(item);
  };

  return (
    <WalletLayout>
      <SearchSelect setCliente={setCliente} setClientes={setClientes} />

      {loading ? (
        <div className="container flex items-center justify-center pt-10">
          <Spinner size={"xl"} thickness="4px" />
        </div>
      ) : null}

      {clientes && clientes.length > 1 && !cliente && (
        <FormList items={clientes} clickProposta={clickProposta} />
      )}

      {cliente && (
        <CreateEditForm selectedItem={null} itemClienteSelecionado={cliente} setLoadingProp={setLoading} />
      )}

    </WalletLayout>
  );
};

export default ReceiverSenderForm;
